import type { Espacos } from '../application/dependencias';
import type { ApiHttp } from './api-http';

/** Membros do quadro (RQ-ACE-018), sobre a chamada autenticada do ApiHttp. */
export function criarApiMembros(api: ApiHttp, quadroUuid: string): Espacos['membros'] {
  const base = `/api/quadros/${quadroUuid}`;
  const nada = async (p: Promise<unknown>) => {
    await p;
  };
  return {
    listar: () => api.chamar('GET', `${base}/membros`),
    trocarGestor: (usuarioUuid, gestorUuid) => nada(api.chamar('PUT', `${base}/membros/${usuarioUuid}/gestor`, { gestorUuid })),
    mudarPapel: (usuarioUuid, entrada) => nada(api.chamar('PUT', `${base}/membros/${usuarioUuid}/papel`, entrada)),
    remover: (usuarioUuid, motivo) => nada(api.chamar('DELETE', `${base}/membros/${usuarioUuid}`, { motivo })),
    reenviarConvite: (uuid) => nada(api.chamar('POST', `${base}/convites/${uuid}/reenviar`, {})),
    convidarDeNovo: (uuid) => api.chamar('POST', `${base}/convites/${uuid}/novo`, {}),
    cancelarConvite: (uuid, motivo) => nada(api.chamar('DELETE', `${base}/convites/${uuid}`, { motivo })),
  };
}
